<template>
    <a-modal width="65%" title="报名列表" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
        :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" wrap-class-name="single-spa-vue" :footer="null">
        <!--        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">-->
        <!--            <a-form-item label="标题" name="title">-->
        <!--                <a-input v-model:value="searchForm.title" placeholder="请输入公告标题" />-->
        <!--            </a-form-item>-->
        <!--            <a-form-item>-->
        <!--                <a-button type="primary" @click="onSearch">查询</a-button>-->
        <!--                <a-button @click="onReset">重置</a-button>-->
        <!--            </a-form-item>-->
        <!--        </a-form>-->
        <!-- <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined />
                </template>
                新增
            </a-button>


        </div> -->
        <!-- <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert> -->
        <a-table :pagination="pagination" :data-source="form.listData" :loading="loading" @change="onTableChange">
            <a-table-column title="企业名称" key="unitName" data-index="unitName" ellipsis></a-table-column>
            <a-table-column title="报名人" key="name" data-index="name"></a-table-column>
            <a-table-column title="电话" key="phone" data-index="phone" ellipsis></a-table-column>
            <a-table-column title="人数" key="applyNum" data-index="applyNum"></a-table-column>
            <a-table-column title="报名时间" key="createdTime" data-index="createdTime"></a-table-column>
        </a-table>
    </a-modal>
</template>
<script>
import { tableListMixin, formMixin } from "@/mixins";
export default {
    name: "index",
    mixins: [tableListMixin, formMixin],
    components: {
    },
    data() {
        return {
            form: {
                id: null
            }
        };
    },
};
</script>
<style scoped lang="less"></style>
